import React from 'react';
import { useCalendarContext } from './Provider';
import Button from '../../Components/Button/Button';

const DayHeader = ({day}) => {
    const {setSchedulingDay} = useCalendarContext();

    return <div className="relative w-full p-2 bg-white/80 backdrop-blur-lg z-30 border-b flex flex-row items-center">
        <h3 className="grow text-lg font-bold text-brand text-center text-nowrap px-2">
            {day.title}
        </h3>
        <div className="shrink-0">
            <Button theme="lightPrimary"
                icon="CalendarCheck"
                onClick={() => setSchedulingDay(day)}
                noShadow
                zeroMargin
            />
        </div>

    </div>
}

export default DayHeader;
